.LoadingPlaceholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
